<template>
  <div class="article-subtopic-block">
    <div class="article-subtopic-header">
      <h1 class="header-title">{{ topicData.maintitle }}</h1>
      <div class="header-description" v-html="topicData.MainDescription"></div>
    </div>
    <div
      v-for="(subtopic, subtopicIndex) in topicData.subtopics"
      :key="subtopicIndex"
      class="subtopic-list-block"
    >
      <div class="subtopic-block1">
        <div class="subtopic-article-inner-block">
          <h2 class="subtopic-title" @click="redirectionToArticle(article.url)">
            {{ subtopic.subtopictitle }}
          </h2>
          <div
            v-for="(article, index) in subtopic.articles"
            :key="index"
            class="subtopic-articles-list"
          >
            <img
              v-if="article.image"
              loading="lazy"
              class="subtopic-article-image"
              :src="article.image.Src"
              :alt="article.image.Alt"
              @click="redirectionToArticle(article.url)"
            />
            <h3 class="subtopic-article-title" @click="redirectionToArticle(article.url)">
              {{ article.title }}
            </h3>
            <span class="subtopic-article-description" v-html="article.Description"></span>
          </div>
        </div>
        <a :href="subtopic.url" class="subtopic-see-all-button">{{
          topicData.filterdata.see_all
        }}</a>
      </div>
      <div class="subtopic-block2">
        <div class="quote-component quotes-block">
          <span class="quote">&#8220;</span>
          <p>{{ subtopic.qoute }}</p>
        </div>
        <img
          v-if="subtopic.image"
          loading="lazy"
          class="subtopic-image"
          :src="subtopic.image.Src"
          :alt="subtopic.image.Alt"
          @click="redirectionToArticle(subtopic.url)"
        />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'article-subtopic-block',
  props: {
    topicData: {
      type: Object,
      required: true,
    },
  },
  methods: {
    redirectionToArticle(url) {
      window.location.href = url;
    },
  },
};
</script>
